import { Component, ViewChild, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AppState, FrameToComeActionTypes, selectFrameToComeOrder } from '@app/core/ngrx';
import { Store } from '@ngrx/store';
import { FrameToComeService } from '@app/core/services';
import { Subscription } from 'rxjs/internal/Subscription';

@Component({
  selector: 'ecp-frame-shipment',
  templateUrl: './frame-shipment.component.html',
  styleUrls: ['./frame-shipment.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class FrameShipmentComponent implements OnInit {
  @ViewChild('outerPaginate', { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  trackingData = new MatTableDataSource(null);
  trackingColumn = ['dropshipName', 'trackingNumber', 'createdDate', 'frameCount'];
  trackingColumnWithExpand = [...this.trackingColumn, 'expand'];
  expandOrder: any | null;
  frameOrder$: Subscription;
  labLocation: any;
  constructor(private store: Store<AppState>, private frameToComeService: FrameToComeService) {
    this.store.dispatch({
      type: FrameToComeActionTypes.LOAD_FRAME_TO_COME_ORDERS,
    });
  }

  ngOnInit(): void {
    this.frameOrder$ = this.store.select(selectFrameToComeOrder).subscribe(
      (f2c: any) => {
        if (f2c) {
          let newf2c = f2c.orders.map((fc, i) => ({ ...fc, isLatest: i === 0 ? true : false }));
          this.trackingData = new MatTableDataSource(newf2c);
          this.trackingData.sort = this.sort;
          this.trackingData.paginator = this.paginator;
        }
      },
      err => {
        console.log(err);
      },
    );
    this.getLabAddresses();
  }
  ngOnDestroy() {
    this.frameOrder$.unsubscribe();
  }
  getLabAddresses() {
    this.frameToComeService.getLabAddressDetails().subscribe(res => {
      this.labLocation = res;
    });
  }
}
